import Countdown from "react-countdown";

const CountdownTimer = ({ endTime, countdownEnded }) => {
  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return <span className="countdown-complete">We're ready!</span>;
    } else {
      return (
        <div>
          <h1>Are you ready?!</h1>
          <div className="d-flex count-down-timer justify-content-center">
            {!!days && (
              <div className="w-25">
                <span className="d-block countdown-number">{days}</span>
                <span className="countdown-notation">
                  {days === 1 ? "DAG" : "DAGEN"}
                </span>
              </div>
            )}
            <div className="w-25">
              <span className="d-block countdown-number">{hours}</span>
              <span className="countdown-notation">UUR</span>
            </div>
            <div className="w-25">
              <span className="d-block countdown-number">{minutes}</span>
              <span className="countdown-notation">MINUTEN</span>
            </div>
            <div className="w-25">
              <span className="d-block countdown-number">{seconds}</span>
              <span className="countdown-notation">SECONDEN</span>
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <div>
      <Countdown
        date={new Date(endTime)}
        renderer={renderer}
        onComplete={countdownEnded}
      />
    </div>
  );
};

export default CountdownTimer;
